// extracted by mini-css-extract-plugin
export default {"container":"_J-z","error":"aK-z","disabled":"bK-z","submit":"cK-z","option":"dK-z","success":"eK-z","failure":"fK-z"};